var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{ref:"heatmap",staticClass:"google-heat-map",attrs:{"center":_vm.center,"zoom":_vm.zoom,"options":_vm.options,"map-type-id":_vm.mapTypeId},on:{"zoom_changed":_vm.zoomChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }